import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Modal,
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  Box
} from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 400,
    maxWidth: '90%',
    borderTop: `4px solid ${theme.palette.warning.main}`
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1)
  },
  warningIcon: {
    color: theme.palette.warning.main,
    marginRight: theme.spacing(1),
    fontSize: 28
  },
  body: {
    padding: theme.spacing(2, 0)
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  updateButton: {
    padding: theme.spacing(1, 5)
  }
}));

const UpdateNotification = ({
  open,
  onUpdate
}) => {
  const classes = useStyles();

  return (
    <Modal
      open={open}
      disableBackdropClick
      disableEscapeKeyDown
    >
      <Card className={classes.root}>
        <CardContent>
          <Box className={classes.header}>
            <WarningIcon className={classes.warningIcon} />
            <Typography variant="h5">App Update Required</Typography>
          </Box>
          <Typography className={classes.body} variant="body1">
            A new version has been deployed with latest improvements and bug fixes.
          </Typography>
        </CardContent>
        <CardActions className={classes.buttonContainer}>
          <Button
            data-cy="apply-update-btn"
            color="primary"
            variant="contained"
            size="large"
            className={classes.updateButton}
            onClick={onUpdate}
          >
            Update Now
          </Button>
        </CardActions>
      </Card>
    </Modal>
  );
};

UpdateNotification.propTypes = {
  open: PropTypes.bool.isRequired,
  onUpdate: PropTypes.func.isRequired
};

export default UpdateNotification; 